import { render, staticRenderFns } from "./CKEditorInput.vue?vue&type=template&id=7e20e1f6&scoped=true"
import script from "./CKEditorInput.vue?vue&type=script&lang=js"
export * from "./CKEditorInput.vue?vue&type=script&lang=js"
import style0 from "./CKEditorInput.vue?vue&type=style&index=0&id=7e20e1f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e20e1f6",
  null
  
)

export default component.exports